var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { Store } from '@ngrx/store';
import { ModalService } from '../../common/modal/modal.indra.service';
var INDRAChangeFlightModalComponent = /** @class */ (function (_super) {
    __extends(INDRAChangeFlightModalComponent, _super);
    function INDRAChangeFlightModalComponent(modalService, store, router) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.router = router;
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRAChangeFlightModalComponent.prototype.ngOnInit = function () {
    };
    INDRAChangeFlightModalComponent.prototype.discardExtras = function () {
        var booking = this.data[0];
        var callback = this.data[1];
        this.closeModal();
        // Reset all extras
        // booking.resetExtras();
        // this.store.dispatch(new BookedTripActions.PutBookedTripAction(booking));
        callback(false, 'res');
    };
    return INDRAChangeFlightModalComponent;
}(AbstractModalContentComponent));
export { INDRAChangeFlightModalComponent };
